export default {
  form: {
    companyName: 'Company Name',
    firstname: 'First Name',
    lastname: 'Last Name',
    username: 'Username',
    email: 'E-mail',
    password: 'Password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    role: 'Role',
    client: 'Shop',
    clientDescription: 'I want to buy beautiful upcycling products.',
    designer: 'Brand',
    designerDescription: 'I want to sell my upcycling products and create brand\'s profile.',
    corporate: 'Corporate client',
    corporateDescription:'I want to look for circular opportunities for my company and upload my company\'s waste streams.',
    company: 'Brand name',
    address1: 'Street address',
    country: 'Country',
    zipcode: 'Postal code',
    state: 'State',
    phone: 'Telephone',
    url: 'Website',
    city: 'City',
    description: 'Brand idea (description)',
    privacyPolicyLabel: 'Privacy Policy',
    termsAndConditionsLabel: 'Terms and conditions',
    termsAndConditionsDescription: 'I hereby acknowledge that I have read, understand and agree to the {terms} and {privacy} of Dekoeko.com marketplace.',
    receiveLatestNewsLabel: 'Receive latest news',
    receiveLatestNewsDescription: 'I agree to receive the latest news about trends, ideas for unique gifts and special promotions at Dekoeko.com via e-mail.',
    cannotCreateAccount: 'Unable to create an account. If you have completed all the fields correctly and the problem persists, please write to us at designers@dekoeko.com',
    freeAccountInfo: 'By creating an account on the Deko Eko platform now, you gain 40 days of free access to all functionalities of the account for business. 10 days before the end of the free period, we will remind you of the upcoming deadline - you will have time to decide whether you keep your account (as a paid version) or suspend it (you will not incur any fees then).'
},
actions: {
  successSignIn: 'Signed in successfully',
    successSignUp: 'Signed up successfully',
  },
  stepper: {
    firstStep: {
      title: 'I want to join Deko Eko as a: ',
      subtitle: 'Role will define your abilities in application',
    },
    secondStep: {
      title: 'Basic information',
    },
    thirdStep: {
      title: 'Your company information',
    },
    next: 'Next',
    back: 'Back',
    sendApplication: 'Send application',
    signUp: 'Sign up'
  },
};
